/**
 * Night Passage Checklist
 * Navigation during hours of darkness
 * Regulatory: COLREGs Part C
 */

export const NIGHT_PASSAGE_CHECKLIST = {
  id: 'night_passage',
  name: 'Night Passage',
  description: 'Navigation during hours of darkness',
  icon: 'Moon',
  regulatory: 'COLREGs Part C',
  isCustomisable: true,
  items: [
    { id: 'np_1', text: 'Navigation lights checked and operational', required: true },
    { id: 'np_2', text: 'Radar operational', required: true },
    { id: 'np_3', text: 'Bridge lighting adjusted for night vision', required: true },
    { id: 'np_4', text: 'Crew rested and watch schedule confirmed', required: true },
    { id: 'np_5', text: 'Torches and searchlight available', required: true },
    { id: 'np_6', text: 'AIS transmitting', required: false }
  ]
};
